<h2>{{ employee.FirstName }} {{employee.LastName }}'s Record for
    {{ Date | date: 'mediumDate'}}</h2>
<!-- <div *ngIf="!IsTechnical()" class="form-group row">
    <label class="col-sm-3 col-form-label">Arrival</label>
    <div class="col-sm-9 my-1">
        <input type="time" class="form-control" [(ngModel)]="Arrival" id="Arrival" #ArrivalTime="ngModel"
            placeholder="hh:mm:ss">
    </div>
    <label class="col-sm-3 col-form-label">Departure</label>
    <div class="col-sm-9 my-1">
        <input type="time" class="form-control" [(ngModel)]="Departure" id="departure" #DepartureTime="ngModel"
            placeholder="hh:mm:ss">
        <span *ngIf="ArrivalTime.value > DepartureTime.value" class="text-danger">Please enter valid time</span>
    </div>
    <label *ngIf="CheckLeave()" class="col-sm-3 col-form-label">Leave Type</label>
    <div *ngIf="CheckLeave()" class="col-sm-9 my-1">
        <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="Type">
            <label ngbButtonLabel class="btn-outline-info" data-toggle="tooltip" placement="top"
                ngbTooltip="Casual Balance at the start of month = {{employee.CasualLeaveBalance}}">
                <input ngbButton type="radio" value="Casual">
                Casual
            </label>
            <label ngbButtonLabel class="btn-outline-info" data-toggle="tooltip" placement="top"
                ngbTooltip="Annual Balance at the start of month = {{employee.AnnualLeaveBalance}}">
                <input ngbButton type="radio" value="Annual">
                Annual
            </label>
            <label ngbButtonLabel class="btn-outline-info">
                <input ngbButton type="radio" value="Leave w/o Pay"> Leave w/o Pay
            </label>
        </div>
    </div>
</div> -->
<div *ngIf="IsTechnical()" class="form-group">
    <div class="row">
        <label class="col-sm-3 col-form-label">Clockify Minutes</label>
        <div class="col-sm-9">
            <input type="text" class="form-control" [ngModel]="clockifyHours" id="clockifyHours" placeholder=" - "
                disabled>
        </div>
    </div>
    <div class="row">
        <label *ngIf="CheckLeave()" class="col-sm-3 col-form-label">Leave Type</label>
        <div *ngIf="CheckLeave()" class="col-sm-9">
            <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="Type">
                <label *ngIf="Type=='Casual'" ngbButtonLabel class="btn-outline-info">
                    <input ngbButton type="radio" value="Casual">
                    Casual
                </label>
                <label *ngIf="Type=='Annual'" ngbButtonLabel class="btn-outline-info">
                    <input ngbButton type="radio" value="Annual">
                    Annual
                </label>
                <label *ngIf="Type=='Leave w/o Pay'" ngbButtonLabel class="btn-outline-info">
                    <input ngbButton type="radio" value="Leave w/o Pay">
                    Leave w/o Pay
                </label>
            </div>
        </div>
    </div>
    <div class="d-flex flex-row-reverse pt-3">
        <button type="button" class="btn btn-outline-dark btn-sm border-0 dropdown-toggle" (click)="collapse.toggle()"
            data-toggle="button" [attr.aria-expanded]="!isCollapsedChange" aria-controls="collapseExample">
            Request a Change
        </button>
    </div>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsedChange">
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <button *ngIf="CheckLeave();" type="button"
                        class="btn btn-outline-dark btn-sm border-0 dropdown-toggle" (click)="ToggleType()"
                        [attr.aria-expanded]="!isCollapsedType" aria-controls="collapseExample1">
                        change leave type
                    </button>
                    <button type="button" class="btn btn-outline-dark btn-sm border-0 dropdown-toggle"
                        (click)="ToggleTime()" [attr.aria-expanded]="!isCollapsedTime" aria-controls="collapseExample2">
                        change timing
                    </button>
                </div>
                <div #collapse1="ngbCollapse" [(ngbCollapse)]="isCollapsedType">
                    <div class="card">
                        <div class="card-body">
                            <label><small>Choose the leave type you want to request</small></label>
                            <div class="d-flex btn-group btn-group-toggle" ngbRadioGroup name="radioBasic"
                                [(ngModel)]="requestType">
                                <label ngbButtonLabel class="btn-outline-info">
                                    <input ngbButton type="radio" value="Casual">
                                    Casual
                                </label>
                                <label ngbButtonLabel class="btn-outline-info">
                                    <input ngbButton type="radio" value="Annual">
                                    Annual
                                </label>
                                <label ngbButtonLabel class="btn-outline-info">
                                    <input ngbButton type="radio" value="Leave w/o Pay">
                                    Leave w/o Pay
                                </label>
                            </div>
                            <label class="pt-4"><small>Add Reason/Comments Here</small></label>
                            <div class="input-group input-group-lg">
                                <textarea name="comment" cols="40" rows="3"
                                    placeholder="I am requesting this change beacuse..." [(ngModel)]="typeComments">
                                </textarea>
                            </div>
                            <button type="button" class="btn btn-outline-success btn-sm mt-4 float-right"
                                (click)="SendTypeRequest()" data-keyboard="false">
                                Send Request
                            </button>
                        </div>
                    </div>
                </div>
                <div #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsedTime">
                    <div class="card">
                        <div class="card-body">
                            <label class="text-wrap">To request a change in timing/work-hours, follow the steps
                                below:</label>
                            <h5>1. Update clockify entries as needed for the Date - {{ Date | date: 'mediumDate'}} </h5>
                            <h5>2. Explain in the text-box below why there is a need for change </h5>
                            <h5>3. Press the "Send Request" button </h5>
                            <h5 class="float-right"><small> Admin will review your request shortly </small></h5>
                            <label class=""><small>Add reason/comments and explain the change you made</small></label>
                            <div class="input-group input-group-lg">
                                <textarea name="comment" cols="40" rows="3"
                                    placeholder="I am requesting this change beacuse..." [(ngModel)]="timeComments">
                                </textarea>
                            </div>
                            <button type="button" class="btn btn-outline-success btn-sm mt-4 float-right"
                                (click)="SendTimeRequest()" data-keyboard="false">
                                Send Request
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <button (click) = "Test()"></button> -->
</div>